<template>
    <div class="container-fluid">
        <div class="mb-1">
            <b-card class="filtre">
                <b-card-title>
                    <h2 class="titol">{{ $t("fitxes.titols.selecciona") }}</h2>
                </b-card-title>
                <b-row>
                    <b-col lg="4" md="10" sm="12">
                        <VariableAmbit
                        v-bind:initialValue="null"
                        @ambit-seleccionat="actualitzarAmbitSeleccionat"
                        />
                    </b-col>
                    <b-col lg="4" md="10" sm="12">
                        <VariableRegio
                        v-bind:initialValue="null"
                        @regio-seleccionat="actualitzarRegioSeleccionat"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="4" md="10" sm="12">
                        <VariableEntitat
                        v-bind:initialValue="null"
                        :ambitSeleccionat="ambitSeleccionat"
                        :regioSeleccionat="regioSeleccionat"
                        @entitat-seleccionat="actualitzarEntitatSeleccionat"
                        />
                    </b-col>
                    <b-col lg="4" md="10" sm="12">
                        <VariableUnitat
                        v-bind:initialValue="null"
                        :ambitSeleccionat="ambitSeleccionat"
                        :regioSeleccionat="regioSeleccionat"
                        :entitatSeleccionat="entitatSeleccionadaOpcio"
                        @unitat-seleccionat="actualitzarUnitatSeleccionat"
                        />
                    </b-col>
                    <b-col lg="4" md="10" sm="12">
                        <b-button
                        class="butoCercar"
                        @click.prevent="getFitxes()">
                            {{$t("fitxes.titols.cerca")}}
                        </b-button>
                    </b-col>
                </b-row>
                <template #footer>
                    <div class="d-flex justify-content-end">
                    <b-button variant="primary"
                                :disabled="!resposta || isLoading || isGeneratingPDF"
                                @click.prevent="exportToPDF"
                                aria-label="Descarrega en PDF">
                        <template v-if="isGeneratingPDF">
                        <b-spinner small class="mr-2" type="border" /> {{ $t('fitxes.titols.generant') }}
                        </template>
                        <template v-else>
                        <i class="bi bi-file-earmark-pdf-fill me-2 text-white"></i> {{ $t('fitxes.titols.pdf') }}
                        </template>
                    </b-button>
                    </div>
                </template>
            </b-card>
            <div v-if="isLoading" class="spinner-wrap">
                <b-spinner
                    label="Buscant dades…"
                    variant="primary"
                    class="d-block mx-auto my-3"
                />
            </div>
            <div v-if="!isLoading && resposta && resposta.resultats">
                <div id="element-to-convert" style="min-height: 100px; background: rgba(255,255,0,0.1);">
                    <div
                    v-for="[clau, dades] in liniesAssistencialsAmbDades"
                    :key="clau"
                    >
                    <ModalTaulaResultatsEnquestaPlaensa
                        :liniaAssistencial="clau"
                        :dadesLiniaAssistencial="dades"
                        :anysDisponibles="dades.anysDisponibles"
                        :ambit="ambitSeleccionat"
                        :regio="regioSeleccionat"
                        :entitat="entitatSeleccionadaOpcio"
                        :unitat="unitatSeleccionadaOpcio"
                        :resposta="resposta"
                    />
                    </div>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>
import fitxesService from "@/services/FitxesService";
import VariableAmbit from "./VariableAmbit.vue";
import VariableRegio from "./VariableRegio.vue";
import VariableEntitat from "./VariableEntitat.vue";
import VariableUnitat from "./VariableUnitat.vue";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ModalTaulaResultatsEnquestaPlaensa from "./ModalTaulaResultatsEnquestaPlaensa.vue";
export default {
  name: "fitxa",
  components:{
    VariableAmbit,
    VariableRegio,
    VariableEntitat,
    VariableUnitat,
    ModalTaulaResultatsEnquestaPlaensa
  },
  computed: {
    liniesAssistencialsAmbDades() {
        if (!this.resposta || !this.resposta.resultats) return [];
        return Object.entries(this.resposta.resultats).filter(
            ([, dades]) => dades && Object.keys(dades).length > 0
        );
    }
  },  
  data() {
    return {
        ambitSeleccionat: "",
        regioSeleccionat: "",
        entitatSeleccionat: "",
        entitatSeleccionadaOpcio: null,
        unitatSeleccionat: "",
        unitatSeleccionadaOpcio: null,
        filtreFitxes:{
            ambit: "",
            regioSanitaria: "",
            entitatProveidora: "",
            unitatProveidora: "",
            resultats: []
        },
        isLoading: false,
        resposta: null,
        acumulatsUrg: null,
        acumulatsAea: null,
        acumulatsAp: null,
        acumulatsHai: null,
        liniaAssistencial: "",
        isGeneratingPDF: false
        };
    },
    watch: {
        ambitSeleccionat()   { this.resposta = null; },
        regioSeleccionat()   { this.resposta = null; },
        entitatSeleccionat() { this.resposta = null; },
        unitatSeleccionat()  { this.resposta = null; }
    },
    methods: {
    async exportToPDF() {
        // 1. muestra el spinner
        this.isGeneratingPDF = true;

        // 2. deja que Vue actualice el DOM
        await this.$nextTick();           

        // 3. genera el PDF 
        await new Promise(r => requestAnimationFrame(r));
        await this.generarPDF();

        // 4. oculta el spinner
        this.isGeneratingPDF = false;

    },
    async generarPDF(){
        const doc = new jsPDF({ unit: 'mm', format: 'a4' });

        const pageWidth = doc.internal.pageSize.getWidth();
        const footerHeight = 15;
        const marginLeft = 10;
        const marginTop = 30;
        const labelWidth = 8;
        const cardMarginLeft = marginLeft;
        const cardWidth = pageWidth - marginLeft * 2;

        const COLOR_SUCCESS = [37, 181, 116];     // verde
        const COLOR_DEFAULT = [182, 184, 184];   // gris
        const COLOR_ERROR   = [225, 115, 109];  // rojo
        const COLOR_CAT   = [98, 163, 226];  // azul

        const getImageBase64 = (url) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = url;
                img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const base64 = canvas.toDataURL("image/png");
                resolve({ base64, width: img.width, height: img.height });
                };
                img.onerror = (err) => reject(err);
            });
        };

        const logo1 = await getImageBase64("/salut.png");
        const logo2 = await getImageBase64("/generalitat.png");

        function colorPorValorDesdeColor(codiColor) {
            if (codiColor === 'VERD') return COLOR_SUCCESS;
            if (codiColor === 'VERMELL') return COLOR_ERROR;
            return COLOR_DEFAULT;
        }

        const drawHeader = (pageNum, totalPages) => {
            doc.setFillColor(144, 0, 0);
            doc.rect(0, 0, pageWidth, 25, 'F');

            // Marca de agua /Salut en segundo plano (izquierda)
            /*doc.saveGraphicsState();
            doc.setTextColor(240, 242, 243);
            doc.setFontSize(92);
            doc.setFont("helvetica", "bold");
            doc.text("/Salut", pageWidth - 90, 24); // debajo del top pero dentro del header
            doc.restoreGraphicsState();*/

            // Título principal en blanco
            doc.setFontSize(14);
            doc.setTextColor(255);
            doc.setFont("helvetica", "bold");
            doc.text(`${this.$t("fitxes.titols.plaensa")}: ${this.$t("fitxes.titols.plaensa2")}`, marginLeft, 17);

            
            // Número de página encima del fondo
            doc.setFontSize(11);
            doc.text(`${String(pageNum).padStart(2, '0')}/${totalPages}`, pageWidth - 25, 16);

            doc.saveGraphicsState();

            
        };

        const drawFooter = () => {

            const footerY = doc.internal.pageSize.getHeight() - footerHeight;

            doc.setFillColor(144, 0, 0); 
            doc.rect(0, footerY, pageWidth, footerHeight, 'F');

            const targetHeight = 8;

            if (logo1?.base64) {
                const aspectRatio1 = logo1.width / logo1.height;
                const targetWidth1 = targetHeight * aspectRatio1;
                doc.addImage(logo1.base64, "PNG", marginLeft, footerY + 2, targetWidth1, targetHeight);
            }

            if (logo2?.base64) {
                const aspectRatio2 = logo2.width / logo2.height;
                const targetWidth2 = targetHeight * aspectRatio2;
                doc.addImage(logo2.base64, "PNG", pageWidth - marginLeft - targetWidth2, footerY + 2, targetWidth2, targetHeight);
            }
        };

        const totalPages = this.liniesAssistencialsAmbDades.length || 1;
        let pageNum = 1;
        drawHeader(pageNum, totalPages);
        drawFooter();

        const titulo = this.$t("fitxes.titols.estas");
        const subtitulo = [
        this.$t("fitxes.titols.resultats") + " " + (this.unitatSeleccionadaOpcio?.text || '') + " " + this.$t("fitxes.titols.resultats2")
        ];

        Object.entries(this.resposta.resultats).forEach(([clau, dades], index) => {
        const any = (dades.anysDisponibles && dades.anysDisponibles[0]) || '?';
        const nomLinia = this.$t("variables.liniaAssistencialFitxes." + clau.toUpperCase());
        const liniaText = `${String.fromCharCode(97 + index)} - ${nomLinia} (any ${any})`;
        subtitulo.push(liniaText);
        });

        const tituloFontSize = 9;
        const subtituloFontSize = 4;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(tituloFontSize);
        doc.text(titulo, cardMarginLeft + 5, marginTop + tituloFontSize + 1); // línea base del título

        doc.setFont("helvetica", "normal");
        doc.setFontSize(subtituloFontSize);

        const subtituloLines = doc.splitTextToSize(subtitulo, cardWidth - 10);
        const subtituloHeight = subtituloLines.length * (subtituloFontSize + 1);
        const leyendaLineHeight = 4;
        const leyendaSpacing = 8; // espacio entre subtítulo y leyenda
        const leyendaBlockHeight = 2 * leyendaLineHeight + 4; // dos líneas de texto + margen

        const totalCardHeight = tituloFontSize + subtituloHeight + leyendaSpacing + leyendaBlockHeight + 3;

        doc.setFillColor(230, 230, 230);
        doc.setLineWidth(0.2);
        doc.roundedRect(cardMarginLeft, marginTop, cardWidth, totalCardHeight, 6, 6, 'F');

        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(titulo, cardMarginLeft + 5, marginTop + 10);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(subtituloLines, cardMarginLeft + 5, marginTop + tituloFontSize + 6);

        const leyendaStartY = marginTop + tituloFontSize + subtituloHeight + leyendaSpacing;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor(0);
        doc.text(this.$t("fitxes.titols.llegendaColors") || "Llegenda de colors:", cardMarginLeft + 5, leyendaStartY);

        // Verde
        doc.setFont("helvetica", "normal");
        doc.setFillColor(...COLOR_SUCCESS);
        doc.rect(cardMarginLeft + 5, leyendaStartY + 2, 4, 4, 'F');
        doc.setTextColor(0);
        doc.text(this.$t("fitxes.llegenda.positiva") || "Verd: diferència estadísticament positiva respecte a Catalunya", 
                cardMarginLeft + 11, leyendaStartY + 6);

        // Rojo
        doc.setFillColor(...COLOR_ERROR);
        doc.rect(cardMarginLeft + 5, leyendaStartY + leyendaLineHeight + 4, 4, 4, 'F');
        doc.text(this.$t("fitxes.llegenda.negativa") || "Vermell: diferència estadísticament negativa respecte a Catalunya",
                cardMarginLeft + 11, leyendaStartY + leyendaLineHeight + 8);


        let offsetY = marginTop + totalCardHeight + 10;

        

        function normalitza(text = "") {
        return text
            // 1) Caracter precompuesto ŀ / Ŀ  →  l·l / L·L
            .replace(/\u0140/g, "l·l")   // ŀ minúscula
            .replace(/\u013F/g, "L·L")   // Ŀ mayúscula

            // 2) Errores habituales que producen "l·ll" o "ll·l"
            .replace(/l·ll/gi, "l·l")    // l·ll  → l·l   (insensible a mayúsc.)
            .replace(/ll·l/gi, "l·l")    // ll·l  → l·l

            // 3) Por si hubiera doble punto volat: "l·l·l"
            .replace(/l·l·l/gi, "l·l");
        }

        this.liniesAssistencialsAmbDades.forEach(([clau, dades], index) => {
            if (index > 0) {
                doc.addPage();
                pageNum++;
                drawHeader(pageNum, totalPages);
                drawFooter();
                offsetY = marginTop;
            }

            let actualStartY = offsetY; // guarda el punto inicial real

            const anysDisponibles = dades.anysDisponibles || [];
            const preguntes = Object.values(dades.preguntes || {});

            // 1. Encabezado dinámico
            const head = [
            '',  // Primera columna: enunciat
            `${this.$t("fitxes.titols.catalunya")} ${anysDisponibles[0]}`, // PercCatalunya siempre del año actual
            ...anysDisponibles.map((any, idx) => {
                return idx === 0
                ? `${this.$t("fitxes.titols.up")} ${any}`                 // año actual
                : `${this.$t("fitxes.titols.up")} ${any}`;                // anteriores
            }),
            
            ];

            // 2. Filas dinámicas
            const rows = preguntes.map(p => {
            const fila = [normalitza(p.enunciat)];
            fila.push(p.percCatalunya || '-');

            anysDisponibles.forEach((any, idx) => {
                // Orden esperado de los campos en base a posición: actual, anterior, anterior2
                const anyIndex = idx === 0 ? 'Actual' :
                                idx === 1 ? 'Anterior' :
                                idx === 2 ? 'Anterior2' : null;

                const key = `percAny${anyIndex}`;
                fila.push(p[key] || '-');
            });

            return fila;
            });
            
            doc.autoTable({
                startY: actualStartY,
                margin: { left: marginLeft + labelWidth + 5 },
                head: [head],
                body: rows,
                styles: {
                    fontSize: 8.5,
                    lineHeight: 1.2,
                    minCellHeight: 8, 
                    cellPadding: { top: 1, right: 1.5, bottom: 1, left: 1.5 },
                    valign: 'middle',
                    overflow: 'linebreak'
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: 0,
                    halign: 'center', 
                    valign: 'middle' 
                },
                columnStyles: {
                    0: { cellPadding: { left: 2, right: 5 }, cellWidth: 95 },
                    1: { cellWidth: 21, halign: 'center' },
                    2: { cellWidth: 21, halign: 'center' },
                    3: { cellWidth: 21, halign: 'center' },
                    4: { cellWidth: 21, halign: 'center' }
                },
                alternateRowStyles: { fillColor: null },
                didDrawPage: (data) => {
                    offsetY = data.cursor.y + 10;
                },
                didDrawCell: function (data) {
                    const { cell, column, section } = data;

                    if (data.section === 'body' && data.column.index === 0) {
                        const spacing = 2;

                        const { x, y, width, height } = data.cell;

                        // Aumenta la altura del rectángulo para simular separación
                        const paddedY = y + spacing / 2;
                        const paddedHeight = height - spacing;

                        doc.setDrawColor(144, 0, 0);
                        doc.setLineWidth(0.3);
                        doc.roundedRect(x, paddedY, width, paddedHeight, 2, 2, 'S');
                    }

                    if (section === 'body' && column.index > 0) {
                        const text = cell.text?.[0] || "";
                        let rgb = COLOR_DEFAULT;

                        if(column.index ===1 ){
                            rgb = COLOR_CAT;
                        }
                        else if (column.index === 2) {
                            const filaIndex = data.row.index;
                            const filaOriginal = preguntes[filaIndex];
                            const colorText = filaOriginal?.color;
                            rgb = colorPorValorDesdeColor(colorText);
                        }  

                        const fontSize = 8.5;
                        doc.setFont("helvetica", "normal"); 
                        doc.setFontSize(fontSize);      

                        const boxWidth = cell.width - 6; 
                        const boxHeight = cell.height - 2;

                        const x = cell.x + (cell.width - boxWidth) / 2;
                        const y = cell.y + (cell.height - boxHeight) / 2;

                        // 1. fondo con el color calculado
                        doc.setFillColor(...rgb);
                        doc.roundedRect(x, y, boxWidth, boxHeight, 2, 2, 'F');

                        // 2. borde del mismo color
                        doc.setDrawColor(...rgb);
                        doc.setLineWidth(0.3);
                        doc.roundedRect(x, y, boxWidth, boxHeight, 2, 2, 'S');
                        doc.setTextColor(255);
                        doc.text(text, cell.x + cell.width / 2, cell.y + cell.height / 2 , {
                            align: 'center',
                            baseline: 'middle'
                        });

                        data.cell.text = []; // evita que autoTable lo vuelva a dibujar
                    }
                }
            });
            const anyLinia = (dades.anysDisponibles && dades.anysDisponibles[0]) || '?';
            const label = `${this.$t("variables.liniaAssistencialFitxes." + clau.toUpperCase())} (${anyLinia})`;
            
            const footerY = doc.internal.pageSize.getHeight() - footerHeight;
            const labelHeight = Math.min(offsetY, footerY - 2.5) - actualStartY;
            
            doc.setFillColor(144, 0, 0);
            doc.roundedRect(marginLeft, actualStartY, labelWidth, labelHeight, 2, 2, 'F');
            doc.saveGraphicsState();
            doc.setFontSize(15);
            doc.setTextColor(255);
            doc.setFont(undefined, 'bold');
            const textX = marginLeft + 6;
            const textY = actualStartY + labelHeight / 2 + 35;
            doc.text(label, textX, textY, null, 90);
            doc.restoreGraphicsState();
        });

        const netejarNomFitxer = (text) => {
            return text
                .normalize("NFD")                 // separa tildes
                .replace(/[\u0300-\u036f]/g, "") // elimina tildes
                .replace(/\s+/g, "_")            // espacios -> guiones bajos
                .replace(/[^\w-]/g, "")         // quita todo menos letras, números y guiones
                .toLowerCase();                  // minúsculas
        };

        const any = this.resposta.anysConsulta[this.resposta.anysConsulta.length - 1];
        const unitatNetejada = this.unitatSeleccionadaOpcio?.text
            ? netejarNomFitxer(this.unitatSeleccionadaOpcio.text)
            : "unitat";

        doc.save(`PLAENSA_${any}_${unitatNetejada}.pdf`);
    },
    
    actualitzarAmbitSeleccionat(ambit){
        this.ambitSeleccionat = ambit;
        console.log("ambit: "+ambit);
        console.log("ambitSeleccionat: "+this.ambitSeleccionat);
    },
    actualitzarRegioSeleccionat(regio){
        this.regioSeleccionat = regio;
        console.log("regio: "+regio);
    },
    actualitzarEntitatSeleccionat(entitat){
        this.entitatSeleccionat = entitat.value;
        this.entitatSeleccionadaOpcio = entitat;
        console.log("entitat: "+entitat);
    },
    actualitzarUnitatSeleccionat(unitat){
        this.unitatSeleccionat = unitat.value;
        this.unitatSeleccionadaOpcio = unitat;
        console.log("unitat: "+unitat);
    },
    async getFitxes(){
        // 1) Oculta tablas anteriores
        this.resposta = null;

        // 2) Muestra spinner
        this.isLoading = true;
        try{
            this.filtreFitxes.ambit = this.ambitSeleccionat;
            this.filtreFitxes.regioSanitaria = this.regioSeleccionat;
            this.filtreFitxes.entitatProveidora = this.entitatSeleccionat;
            this.filtreFitxes.unitatProveidora = this.unitatSeleccionat;
        
            console.log("Filtre: " + JSON.stringify(this.filtreFitxes, null, 2));
            const response = await fitxesService.listFiltreAdminFitxes(
                this.filtreFitxes
            );
            this.resposta = response.data;
            console.log("Resposta acumulats:");
            console.log(response.data);
            this.isLoading = false;
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }
 
  },
  mounted() {

  },
  created(){
    this.isLoading = false;
  }
  
};
</script>

<style scoped>

.filtre{
    border-color: #6ba8e3;
    background-color: #f0f2f3;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    width: 100%;
}

h2.titol {
    text-align: left;
    margin-left: 14px;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.form-container {
  background-color: #f4f6f8;
  border: 1px solid #90c4e4;
  border-radius: 8px;
  padding: 16px;
  max-width: 800px;
  margin: 10px auto;
  font-family: Arial, sans-serif;
}

h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

select {
    font-size: 13px;
    border-radius: 10px;
    border: 1px solid #8ebbe7;
}

button {
  background-color: #4da4e0;
  color: white;
  font-weight: bold;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  float: right;
}

button:hover {
  background-color: #378ac9;
}

h2.titol {
    text-align: left;
    margin-left: 14px;
    font-family: calibri;
    float: left;
    width: 100%;
}

.formulari{
    text-align: left;
    margin-left: 5px;
}
label {
    display: inline-block;
    margin-bottom: 0.5rem;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
}
.select {
    font-size: 13px;
    border-radius: 10px;
    border: 1px solid #8ebbe7;
    background-color: #ffffff00;
}

button.butoCercar {
    padding: 0;
    width: 6.5rem;
    text-align: left;
    padding-left: 0.5rem;
    margin-right: 0.5rem;
    margin-bottom: 1rem;
}

.butonContainer{
    float: left;
    width: 100%;
}

.b-spinner {
  font-size: 2rem;
}

.spinner-wrap {
  clear: both; 
  margin-top: 1rem;
}

.btn-export {
  width: 6.5rem;    
  padding: 0 0.5rem;
  text-align: center;
}

</style>
<!-- #6ba8e3-->